import * as braze from '@braze/web-sdk';

export const initializeBraze = (key: string) => {
  // initialize the SDK
  braze.initialize(key, {
    baseUrl: 'sdk.iad-06.braze.com'
  });
};
